/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgUserOutline = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.213 8.69h-2.42A5.298 5.298 0 001.5 13.98l.5.5h12l.5-.5a5.297 5.297 0 00-5.287-5.29zM2.53 13.48a4.298 4.298 0 014.263-3.79h2.42a4.297 4.297 0 014.25 3.79H2.53zM8.012 8a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0-6a2.5 2.5 0 110 5 2.5 2.5 0 010-5z"
}));

export default SvgUserOutline;